<template>
    <div class="tw-p-2 tw-bg-white tw-w-full tw-border tw-border-solid tw-flex tw-items-center tw-gap-2">
        <router-link :to="{ name: 'pages.dashboard.admin' }"
            class="tw-text-gray-400 tw-duration-200 hover:tw-text-gray-700 tw-text-xl tw-flex tw-items-center tw-gap-2">
            <icon icon="solar:home-smile-bold-duotone" /> <span class="tw-text-sm">{{ $t("dashboard.sidebar.dashboard")
                }}</span>
        </router-link>
        <span class="tw-text-gray-300">/</span>
        <button disabled class="tw-text-primary-500 tw-text-xl tw-flex tw-items-center tw-gap-2"><span
                class="tw-text-sm">{{
                    $t("dashboard.sidebar.ads") }}</span></button>
    </div>
    <div class="tw-p-2">
        <div
            class="tw-h-full tw-w-full tw-p-4 tw-bg-white tw-rounded tw-border tw-border-b-2 tw-min-h-[calc(100dvh-125px)]">
            <div class="tw-justify-between tw-flex tw-items-center tw-h-[40px] tw-gap-2">
                <div class="tw-flex tw-items-center tw-gap-2">
                    <div class="tw-flex tw-items-center">
                        <FormField v-model="search" input-dir="ltr" placeholder="ID, Name..." left-icon="clarity:search-line"
                            type="text" class="tw-min-w-[100px] tw-peer" 
                            input-class="ltr:tw-rounded-e-none ltr:tw-border-e-0 rtl:!tw-border-s-0 rtl:tw-rounded-e rtl:tw-border-e rtl:tw-rounded-s-none tw-mb-0.5" />
                        <select @change="onPerPageChange" v-model="options.per_page" class="tw-w-[40px] tw-text-sm tw-outline-none peer-focus-within:tw-border-y-primary-500 tw-border-e-0 tw-text-center tw-h-[40px] tw-border tw-border-solid tw-border-gray-200 tw-duration-200">
                            <option v-for="item in [5, 10, 20, 50, 75, 100]" :key="item" :value="item" class="tw-px-2">{{ item }}</option>
                        </select>
                        <a-button @click="onSearch"
                            class="tw-h-[40px] !tw-rounded-s-none tw-border-s !tw-border-b peer-focus-within:tw-border-y-primary-500 peer-focus-within:tw-border-e-primary-500 active:!tw-translate-y-0"
                            icon="clarity:search-line" intent="icon"></a-button>

                    </div>
                    <a-button @click="visible.filters = !visible.filters" class="tw-h-[40px] !tw-border-b" intent="icon"
                        icon="solar:filter-bold-duotone"></a-button>

                    <a-button as="router-link" :to="{ name: 'pages.admin.ads.analytics' }" class="tw-h-[40px] !tw-border-b" intent="icon"
                        icon="solar:chart-2-bold-duotone"></a-button>

                    <AdKPIsWidget :kpis="kpis" :loading="loading" />
                </div>

                <ad-create-popup />
            </div>
            <div>
                <AdFilterWrapper v-model:filters="filters" v-model:visible="visible.filters" @filter="onFilter"  />
            </div>
            <div class="tw-mt-5 tw-roundedx tw-overflow-hiddenx">
                <AdTable :loading="loading" :items="ads" :options="options" @next="onNext" @previous="onPrevious" />
            </div>
        </div>

    </div>
</template>

<script setup>
import { ref, provide, watch } from 'vue'
import { paginate } from '@/api/ads';
import FormField from "@/components/form/FormField";
import AdTable from '@/views/admin/ads/partials/table/AdTable';
import AdCreatePopup from '@/views/admin/ads/partials/AdCreatePopup';
import AdFilterWrapper from '@/views/admin/ads/partials/filters/AdFilterWrapper';
import AdKPIsWidget from '@/views/admin/ads/partials/table/AdKPIsWidget';

const search = ref('')
const loading = ref(true)
const ads = ref([]);
const kpis = ref({
    spend: 0,
    results: 0
});
const options = ref({
    per_page: 10
});
const filters = ref({ product_id: [] });
const visible = ref({
    filters: false
});

async function fetchAds(page = 1) {
    loading.value = true;
    ads.value = [];
    await paginate({ per_page: options.value.per_page, page, filters: filters.value, search: search.value })
        .then(
            ({ data }) => {
                const { data: items, ...ops } = data.data;
                options.value = ops
                ads.value = items;
                kpis.value = data.kpis
            },
            error => {
                console.log(error)
            }
        )
    loading.value = false
}

watch(
    () => options.value.per_page,
    () => {
        fetchAds();
    }
)

const onNext = () => {
    fetchAds(options.value.current_page + 1)
}

const onFilter = () => {
    fetchAds()
}

const onSearch = () => {
    fetchAds(1)
}

const onPerPageChange = () => {
    fetchAds()
}

const onPrevious = () => {
    fetchAds(options.value.current_page - 1)
}

const onCreated = (ad) => {
    ads.value.unshift(ad)
}

const onUpdated = (ad) => {
    ads.value = ads.value.map(u => u.id == ad.id ? ad : u)
}

const onDeleted = (id) => {
    ads.value = ads.value.filter(u => u.id != id)
}

provide('onCreated', onCreated)
provide('onUpdated', onUpdated)
provide('onDeleted', onDeleted)

fetchAds()
</script>

<style></style>